import React, { Component } from 'react';
import { cloneDeep, clone, random } from 'lodash'

import Board from './Board'
import { TileTypes } from './constants'
import {
    makeGrid,
    noAdjacentThreesInAColumn,
    noAdjacentThreesInARow,
    noDuplicateRows,
    noDuplicateColumns,
    equalRedsAndBluesInEachColumn,
    equalRedsAndBluesInEachRow
} from './grid'

import { Games } from './config'

interface AppState {
    grid: any;
    isGridSolved: boolean;
    gameId: string;
}

export default class App extends Component<any, AppState> {
    constructor(props: any) {
        super(props)

        this.state = {
            grid: {
                rows: []
            },
            isGridSolved: false,
            gameId: ''
        }
    }

    onTileClick(tile: any) {
        console.log('Got click on tile: ', tile)
        let updatedTile = clone(tile)
        if (!tile.isLocked) {
            updatedTile.tileType = getNextTileType(tile)
        }
        const updatedGrid = replaceTileInGrid(this.state.grid, updatedTile)
        this.setState({
            grid: updatedGrid,
            isGridSolved: isGridSolved(updatedGrid)
        })

    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let level = urlParams.get('level') || 'six';
        
        const onTileClick = this.onTileClick.bind(this)
        // const grid = makeGrid({ size: 6, redsAt: [[1, 1],[1,4],[3,4],[3,5]], bluesAt: [[0,0],[0,2],[2,0],[3,2],[4,4]], onTileClick })
        const games: any = Games[level]
        const gameCount = Object.keys(games).length
        const game = games[`${level}-${random(1, gameCount)}`]
        const grid = makeGrid(game.startState, onTileClick)
        this.setState({
            grid,
            gameId: game.id
        })

    }

    render() {
        console.log('render > grid', this.state.grid)
        return (
            <div>
                <h1>Bet you can't solve this</h1>
                <h4>Level: {this.state.gameId}</h4>
                <p className="top-nav">All levels: <a href="/?level=six">six</a><a href="/?level=eight">eight</a><a href="/?level=ten">ten</a>  </p>
                <Board grid={this.state.grid} />
                {this.state.isGridSolved && <h1>Well done!</h1>}
                <div>
                    <h4>How to play</h4>
                    <p>Toggle the colours of the tiles till every time is blue or red. Keep clicking a tile to cycle through the colours.</p>
                    <p>To solve the puzzle, the following conditions must be fulfilled:</p>
                    <ul>
                        <li>Every row and column must have an equal number of red and blue tiles.</li>
                        <li>There cannot be more than two tiles of the same colour next to each other.</li>
                        <li>No two rows must be identical. No two columns either.</li>
                    </ul>
                </div>
            </div>
        )
    }
}


function getNextTileType(tile: any) {
    if (tile.isLocked) {
        return tile.tileType
    }
    switch (tile.tileType) {
        case TileTypes.Blue: return TileTypes.Empty
        case TileTypes.Red: return TileTypes.Blue
        default: return TileTypes.Red
    }
}

function replaceTileInGrid(originalGrid: any, tile: any) {
    const newGrid = cloneDeep(originalGrid)
    newGrid.rows[tile.row].tiles[tile.column] = tile
    return newGrid
}

function isGridSolved(grid: any) {
    return noAdjacentThreesInARow(grid) &&
        noAdjacentThreesInAColumn(grid) &&
        equalRedsAndBluesInEachRow(grid) &&
        equalRedsAndBluesInEachColumn(grid) &&
        noDuplicateRows(grid) &&
        noDuplicateColumns(grid)
}



